import { FiTwitter, FiInstagram } from 'react-icons/fi'
import { ImSoundcloud, ImFacebook, ImTumblr } from 'react-icons/im'

const socialLinks = [
  { path: 'https://instagram.com/bruceblay/', icon: <FiInstagram /> },
  { path: 'https://twitter.com/MeltingSeason', icon: <FiTwitter /> },
  { path: 'https://soundcloud.com/MeltingSeason', icon: <ImSoundcloud /> },
  { path: 'https://www.facebook.com/meltingseasonmusic', icon: <ImFacebook /> },
  { path: 'http://harmoni-petdeluxe.tumblr.com/', icon: <ImTumblr /> },
]

export default function CevSocial() {
  return (
    <div>
      <p>social</p>

      <div className='bordered-bottom'>
        { socialLinks.map( link => 
          <a 
            key={ link.path }
            href={ link.path }
            className='inline'
            target='_blank'
            rel='noopener noreferrer'>
            { link.icon }
          </a>
        ) }
      </div>
    </div>
  )
}